export default function buildGescomContact(data) {
  const gescomData = {
    ...data,
    typesContactIds: data.typeContactId ? [data.typeContactId] : [],
    accesPortail: data.accesPortail || false,
  };
  delete gescomData.typeContactId;
  return gescomData;
}
